import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../reducers.index';
import { CmsPageState } from '@boels/models';

export const selectCms = createSelector(
  fromFeature.getStoreState,
  (state: fromFeature.BoelsState) => state?.cmsState,
);

export const selectPages = createSelector(
  selectCms,
  (state: CmsPageState) => state.entities,
);

export const selectActivePage = createSelector(
  selectCms,
  (state: CmsPageState) => state.active,
);

export const previousPage = createSelector(
  selectCms,
  (state: CmsPageState) => state.previousLabel,
);

export const selectIsCmsRoute = createSelector(
  selectCms,
  (state: CmsPageState) => state.isCmsRoute,
);
